"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeader = exports.StyledGroupHeader = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const component_enhancer_1 = require("@clds/component-enhancer");
const component_theme_1 = require("@clds/component-theme");
const typography_1 = require("@clds/typography");
exports.StyledGroupHeader = styled_components_1.default.div `
  ${({ size, tone }) => typography_1.typography[size][tone]};
  padding: ${component_theme_1.globalTheme.spacing.xs} ${component_theme_1.globalTheme.spacing.sm};
`;
exports.GroupHeader = (0, component_enhancer_1.asStyledComponent)((props) => (react_1.default.createElement(exports.StyledGroupHeader, Object.assign({ size: "sm", tone: "lowContrast" }, props))));
//# sourceMappingURL=GroupHeader.js.map